export default __webpack_public_path__ + "static/media/19en.b82ed532.mp3";